import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import classNames from 'classnames';
import React from 'react';

import * as constants from './constants';
import TaskStatusCardDescription from './TaskStatusCardDescription';
import TaskStatusCardInfo from './TaskStatusCardInfo';
import TaskStatusCardProgress from './TaskStatusCardProgress';

const useStyles = makeStyles({
  taskCard: {
    position: 'relative',
    minHeight: 80,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: colors.neutral2,
    boxShadow: 'none',
    padding: 0,
  },
  activeTaskCard: {
    backgroundColor: colors.white,
    boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.04)',
  },
  taskCardContent: {
    padding: '15px 16px !important',
  },
});

const TaskStatusCard = ({
  isInitialTask,
  isTaskPortal,
  status,
  label,
  date,
  user,
  completedSubtasksCount,
  totalSubtasksCount,
  remainingDays,
  overdueDays,
}) => {
  const classes = useStyles();
  const isSingleTask = () => !(totalSubtasksCount >= constants.MIN_TOTAL_SUBTASKS_COUNT);

  return (
    <Card
      classes={{
        root: classNames(classes.taskCard, {
          [classes.activeTaskCard]: status === constants.taskStatuses.ACTIVE,
        }),
      }}
      elevation={0}
    >
      <CardContent className={classes.taskCardContent}>
        {isSingleTask() && (
          <TaskStatusCardInfo
            isInitialTask={isInitialTask}
            isTaskPortal={isTaskPortal}
            status={status}
            label={label}
            date={date}
            user={user}
            remainingDays={remainingDays}
            overdueDays={overdueDays}
          />
        )}
        <TaskStatusCardDescription
          status={status}
          label={label}
          date={isSingleTask() && date}
          isTaskPortal={isTaskPortal}
        />
        {status === constants.taskStatuses.ACTIVE && !isSingleTask() && (
          <TaskStatusCardProgress
            completedSubtasksCount={completedSubtasksCount}
            totalSubtasksCount={totalSubtasksCount}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default TaskStatusCard;
